export default __webpack_public_path__ + "static/media/edit.cce4daad.svg";